import { render, staticRenderFns } from "./BtnMenuSup.vue?vue&type=template&id=913ca1c2"
import script from "./BtnMenuSup.vue?vue&type=script&lang=js"
export * from "./BtnMenuSup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports